<template >
    <div class="box">
        <VideoPlayError v-if="showErorr" :theme="2" :liveText="errorInfor.liveText" :teacher="errorInfor.teacher"
            :time="errorInfor.time" :title="errorInfor.title" />
        <div v-else class="video">
            <video id="player-container-id" fluid="ture" width="100%" height="100%" controls="false" preload="auto"
                playsinline webkit-playsinline class="videos">
            </video>
            <div class="button" @click="play()" v-if="!isPlay">
                <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38">
                    <g transform="translate(-91.948 -98.949)">
                        <g transform="translate(91.948 98.949)">
                            <circle cx="19" cy="19" r="19" opacity="0.8" />
                            <path
                                d="M418.2,319.108a1.384,1.384,0,0,0-2.2,1.12v14.695a1.384,1.384,0,0,0,2.2,1.118l10.1-7.347a1.384,1.384,0,0,0,0-2.239Z"
                                transform="translate(-401.223 -308.489)" fill="#fff" />
                        </g>
                    </g>
                </svg>
            </div>
        </div>
    </div>
</template>
<script>
import VideoPlayError from './VideoPlayError.vue';
let player;
export default {
    props: {
        src: "",
        errorInfor: Object
    },
    data() {
        return {
            showErorr: false,
            isPlay: false//是否已经播放
        };
    },
    mounted() {
        // player-container-id 为播放器容器 ID，必须与 html 中一致
        player = TCPlayer("player-container-id", {
            autoplay: true,
            controls: false, //是否显示播放器的控制栏。
            poster: require('../../assets/images/live/playing/error_vertical_backround.png'),

        });
        player.src(this.src); // url 播放地址
        player.on("error", (error) => {
            this.showErorr = true
        });
        player.ready(() => {
            player.play()
            this.initPlayButton()
        })


        player.on('play', (error) => {
            this.isPlay = true
        });

    },
    methods: {
        initPlayButton() {
            setTimeout(() => {
                document.querySelector(".vjs-button-icon").innerHTML = `  
                        <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38">
                            <g  transform="translate(-91.948 -98.949)">
                                <g transform="translate(91.948 98.949)">
                                    <circle  cx="19" cy="19" r="19" opacity="0.8" />
                                    <path 
                                        d="M418.2,319.108a1.384,1.384,0,0,0-2.2,1.12v14.695a1.384,1.384,0,0,0,2.2,1.118l10.1-7.347a1.384,1.384,0,0,0,0-2.239Z"
                                        transform="translate(-401.223 -308.489)" fill="#fff" />
                                </g>
                            </g>
                        </svg>
                    `
            })
        },
        // 播放
        play() {
            player.play()
        }
    },
    components: { VideoPlayError }
}
</script>
<style lang="scss" scoped>
.videos {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

.button {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 20px;
    height: 20px;
    z-index: 100;
    transform: translate3d(-20px, -20px, 0);
    opacity: .7;
}
</style>